/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPwc = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.066 11.041c.761-.458 1.025-.534 1.43-.534.9 0 1.583.824 1.583 1.969 0 1.312-.916 2.212-2.314 2.212-.156 0-.42-.016-.699-.03l.683 1.465v.38H2.063v-.38l.62-.153v-4.61H2v-.381l1.63-.489h.436zm.466.32c-.093 0-.234.016-.467.062l.001 2.746H4.3c.839 0 1.305-.504 1.305-1.51 0-.84-.373-1.297-1.072-1.298zm12.225-.901c.947.001 1.615.444 1.615 1.07 0 .411-.31.701-.76.701-.234 0-.42-.076-.684-.213l-.127-1.072c-.617.161-.945.67-.945 1.514 0 .916.497 1.526 1.227 1.526.357 0 .668-.122 1.32-.442v.747c-.792.366-1.258.458-1.88.458-.698 0-1.195-.168-1.583-.58a2.065 2.065 0 0 1-.622-1.51c0-1.298.994-2.198 2.439-2.198zm-3.2 0c.434 0 .745.336.746.718 0 .286-.132.538-.466.974l-2.004 2.537h-1.165v-2.565l-1.585 2.565h-1.04v-3.312l-.823-.076v-.382l1.506-.336h.56v2.67l1.646-2.67h.994v3.113l1.04-1.373v-1.602a.85.85 0 0 1 .59-.26zm2.556-1.04h-4.38l.685-1.21h4.426zm5.157-1.21h-4.38L17.574 7H22z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPwc as Pwc };
